import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { getStatusMessage } from '../../utils/response-code-messages';
import Snackbar from '../../common/snackBar';

import get from 'lodash/get';
import { GatewayDataRequestActionTypes, SearchtActionTypes } from '../models/gateway-master-service';

const page_name = 'gatewayMaster';

interface Gateway {
  id: string | number;
  gateway_id: string | number;
  controllers: number;
  displayName: string;
  transferStatus: boolean;
}

export interface gatewayMasterState {
  isGatewayMasterDataLoading: boolean;
  gatewayMasterData: Array<Gateway>;
  gatewayMasterDataTotalRowCount: number;
  gatewayMasterDataPageNumber: number;
  gatewayMasterDataError: boolean;
  isAddGatewayLoading: boolean;
  isAddGatewaySuccess: boolean;
  isAddGatewayError: boolean;
  isUpdateGatewayLoading: boolean;
  isUpdateGatewaySuccess: boolean;
  isUpdateGatewayError: boolean;
  isRemoveGatewayLoading: boolean;
  isRemoveGatewaySuccess: boolean;
  isRemoveGatewayError: boolean;
  gatewayMasterMessage: string;
  searchItem: undefined | string;
  gatewayPageName:string;
}

const initialState: gatewayMasterState = {
  isGatewayMasterDataLoading: false,
  gatewayMasterData: [],
  gatewayMasterDataTotalRowCount: 0,
  gatewayMasterDataPageNumber: 1,
  gatewayMasterDataError: false,
  isAddGatewayLoading: false,
  isAddGatewaySuccess: false,
  isAddGatewayError: false,
  isUpdateGatewayLoading: false,
  isUpdateGatewaySuccess: false,
  isUpdateGatewayError: false,
  isRemoveGatewayLoading: false,
  isRemoveGatewaySuccess: false,
  isRemoveGatewayError: false,
  gatewayMasterMessage: '',
  searchItem: '',
  gatewayPageName:'Gateway'
};

const gatewayMasterReducer = createSlice({
  name: page_name,
  initialState: initialState,
  reducers: {
    getGatewayDataRequest: (state, action: GatewayDataRequestActionTypes) => {
      state.isGatewayMasterDataLoading = true;

      state.isAddGatewaySuccess = false;
      state.isUpdateGatewaySuccess = false;
      state.isRemoveGatewaySuccess = false;
      state.gatewayPageName = get(action,'payload.pageName','Gateway')
    },
    getGatewayDataResponse: (state, action: PayloadAction<any>) => {
      state.isGatewayMasterDataLoading = false;
      if (state.searchItem === get(action, 'payload.search_item', '')) {
        state.gatewayMasterData = get(action, 'payload.data', []);
        state.gatewayMasterDataTotalRowCount = get(action, 'payload.total_count', 0);
        state.gatewayMasterDataPageNumber = get(action, 'payload.page', 0);
      }
    },
    getGatewayDataFailed: (state, action: PayloadAction<any>) => {
      state.isGatewayMasterDataLoading = false;
      state.gatewayMasterDataError = true;
      state.gatewayMasterData = [];

      const message = getStatusMessage(page_name, action.payload);
      state.gatewayMasterMessage = message;
      Snackbar.error(message.replace('Gateway',state.gatewayPageName));
    },
    addGatewayRequest: (state) => {
      state.isGatewayMasterDataLoading = true;
      state.isAddGatewayLoading = true;
      state.isAddGatewaySuccess = false;
      state.isAddGatewayError = false;
    },
    addGatewayResponse: (state, action: PayloadAction<any>) => {
      state.isAddGatewayLoading = false;
      state.isAddGatewaySuccess = true;
      state.isGatewayMasterDataLoading = false;

      const message = getStatusMessage(page_name, action.payload);
      state.gatewayMasterMessage = message;
      Snackbar.success(message.replace('Gateway',state.gatewayPageName));
    },
    addGatewayFailed: (state, action: PayloadAction<any>) => {
      state.isGatewayMasterDataLoading = false;
      state.isAddGatewayLoading = false;
      state.isAddGatewayError = true;

      const message = getStatusMessage(page_name, action.payload);
      state.gatewayMasterMessage = message;
      Snackbar.error(message.replace('Gateway',state.gatewayPageName));
    },
    updateGatewayRequest: (state) => {
      state.isGatewayMasterDataLoading = true;
      state.isUpdateGatewayLoading = true;
      state.isUpdateGatewaySuccess = false;
      state.isUpdateGatewayError = false;
    },
    updateGatewayResponse: (state, action: PayloadAction<any>) => {
      state.isGatewayMasterDataLoading = false;
      state.isUpdateGatewayLoading = false;
      state.isUpdateGatewaySuccess = true;

      const message = getStatusMessage(page_name, action.payload);
      state.gatewayMasterMessage = message;
      Snackbar.success(message.replace('Gateway',state.gatewayPageName));
    },
    updateGatewayFailed: (state, action: PayloadAction<any>) => {
      state.isGatewayMasterDataLoading = false;
      state.isUpdateGatewayLoading = false;
      state.isUpdateGatewayError = true;

      const message = getStatusMessage(page_name, action.payload);
      state.gatewayMasterMessage = message;
      Snackbar.error(message.replace('Gateway',state.gatewayPageName));
    },
    removeGatewayRequest: (state) => {
      state.isGatewayMasterDataLoading = true;
      state.isRemoveGatewayLoading = true;
      state.isRemoveGatewaySuccess = false;
      state.isRemoveGatewayError = false;
    },
    removeGatewayResponse: (state, action: PayloadAction<any>) => {
      state.isGatewayMasterDataLoading = false;
      state.isRemoveGatewayLoading = false;
      state.isRemoveGatewaySuccess = true;

      const message = getStatusMessage(page_name, action.payload);
      state.gatewayMasterMessage = message;
      Snackbar.success(message.replace('Gateway',state.gatewayPageName));
    },
    removeGatewayFailed: (state, action: PayloadAction<any>) => {
      state.isGatewayMasterDataLoading = false;
      state.isRemoveGatewayLoading = false;
      state.isRemoveGatewayError = true;

      const message = getStatusMessage(page_name, action.payload);
      state.gatewayMasterMessage = message;
      Snackbar.error(message.replace('Gateway',state.gatewayPageName));
    },
    resetLoadingState: (state) => {
      state.isAddGatewaySuccess = false;
      state.isAddGatewayError = false;
      state.isAddGatewayLoading = false;
      state.isUpdateGatewaySuccess = false;
      state.isUpdateGatewayError = true;
      state.isRemoveGatewaySuccess = false;
      state.isRemoveGatewayError = false;
      state.gatewayMasterMessage = '';
      state.gatewayMasterDataError = false;
    },
    resetGatewayMasterData: (state) => {
      state.gatewayMasterData = [];
      state.gatewayMasterDataTotalRowCount = 0;
      state.gatewayMasterDataPageNumber = 1;
      state.searchItem = '';
    },
    onSearchForItem: (state, action: SearchtActionTypes) => {
      state.searchItem = action.payload;
    },
  },
});

export const gatewayMasterActions = gatewayMasterReducer.actions;
export default gatewayMasterReducer;
